import themeConfig from '@config/theme.config';

export const DRAWER_WIDTH = themeConfig.drawerWidth;
export const MOBILE_DRAWER_MAX_WIDTH = 300;
export const HEADER_HEIGHT = themeConfig.headerHeight;
export const CONTENT_MAX_WIDTH = themeConfig.contentMaxWidth;
